import React from 'react';
import styled from 'styled-components';

import Bullet from './Bullet';
import TimelineContent from './TimelineContent';

const Container = styled.div`
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
`;

const TimelineItem = props => (
  <Container>
    <Bullet />
    <TimelineContent {...props} />
  </Container>
);

export default TimelineItem;
